var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showNotification || _vm.hasError
    ? _c(
        "div",
        [
          _vm.showNotification
            ? _c(
                "article",
                {
                  staticClass: "notification mb15-xs is-danger",
                  attrs: { role: "alert" },
                },
                [
                  _c("div", { staticClass: "media" }, [
                    _c("div", { staticClass: "media-content" }, [
                      _vm.v && _vm.v.$error
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("pleaseProvideAllInformation"))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasError
                        ? _c("span", [
                            _c(
                              "p",
                              { staticClass: "lg" },
                              [
                                typeof _vm.eInfo == "string"
                                  ? [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.eInfo) +
                                          "\n                        "
                                      ),
                                    ]
                                  : _vm.eInfo &&
                                    _vm.eInfo.response &&
                                    _vm.eInfo.response.data &&
                                    _vm.eInfo.response.data.message
                                  ? [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.eInfo.response.data.message
                                          ) +
                                          "\n                            "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "txt strong",
                                          attrs: {
                                            href: "javascript:void(0);",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              _vm.showErrorDetails = true
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("details")) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm.eInfo && _vm.eInfo.status
                                  ? [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.eInfo.status) +
                                          " " +
                                          _vm._s(_vm.eInfo.code) +
                                          " " +
                                          _vm._s(_vm.eInfo.message) +
                                          "\n                            "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "txt strong",
                                          attrs: {
                                            href: "javascript:void(0);",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              _vm.showErrorDetails = true
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("details")) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("somethingWentWrong")) +
                                          "\n                        "
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasError
            ? [
                _c("modal", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "modal-title" }, [
                              _vm._v(_vm._s(_vm.$t("somethingWentWrong"))),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              [
                                _vm.eInfo
                                  ? _c(
                                      "div",
                                      { staticClass: "tags has-addons" },
                                      [
                                        _vm.eInfo.response
                                          ? _c(
                                              "span",
                                              { staticClass: "tag is-danger" },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.eInfo.response.status
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.eInfo.status
                                          ? _c(
                                              "span",
                                              { staticClass: "tag is-danger" },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(_vm.eInfo.status) +
                                                    "\n                        "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.eInfo.config
                                          ? _c("span", { staticClass: "tag" }, [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(_vm.eInfo.config.url) +
                                                  "\n                        "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.eInfo && _vm.eInfo.message
                                  ? [
                                      _c("p", { staticClass: "lg mb15-xs" }, [
                                        _vm._v(
                                          _vm._s(_vm.eInfo.code) +
                                            " " +
                                            _vm._s(_vm.eInfo.message)
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.eInfo &&
                                _vm.eInfo.request &&
                                _vm.eInfo.request.data
                                  ? [
                                      _c("div", [_vm._v("Request:")]),
                                      _vm._v(" "),
                                      _c("pre", { staticClass: "scroll" }, [
                                        _vm._v("                            "),
                                        _c("code", [
                                          _vm._v(
                                            _vm._s(_vm.eInfo.request.data)
                                          ),
                                        ]),
                                        _vm._v("\n                        "),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.eInfo &&
                                _vm.eInfo.response &&
                                _vm.eInfo.response.data
                                  ? [
                                      _c("div", [_vm._v("Response:")]),
                                      _vm._v(" "),
                                      _c("pre", { staticClass: "scroll" }, [
                                        _vm._v("                            "),
                                        _c("code", [
                                          _vm._v(
                                            _vm._s(_vm.eInfo.response.data)
                                          ),
                                        ]),
                                        _vm._v("\n                        "),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.eInfo && _vm.eInfo.stack
                                  ? [
                                      _c("div", [_vm._v("Stack:")]),
                                      _vm._v(" "),
                                      _c("pre", { staticClass: "scroll" }, [
                                        _vm._v("                            "),
                                        _c("code", [
                                          _vm._v(_vm._s(_vm.eInfo.stack)),
                                        ]),
                                        _vm._v("\n                        "),
                                      ]),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2704952142
                  ),
                  model: {
                    value: _vm.showErrorDetails,
                    callback: function ($$v) {
                      _vm.showErrorDetails = $$v
                    },
                    expression: "showErrorDetails",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }